import updateStorages from 'core/controllerPlans/updateStorages'
import appStateUpdated from 'utils/appStateUpdated'
import store from 'utils/store/withMiddleware'
import once from 'utils/functional/once'
import initPage from 'core/initPage'
import updateDOM from './updateDOM'
import initDOM from './initDOM'
import config from './config'
import './styles.scss'
import forbidBTM from 'core/controllerPlansBTM/forbidBTM'

function handleInit() {
  store.registry([once(initDOM), updateDOM, appStateUpdated])
  store.update({})
}

initPage({
  placement: config.PLACEMENT,
  tags: ['Landing']
})
  .then(forbidBTM)
  .then(updateStorages)
  .then(handleInit)
